var map = {
	"./arrow-left.svg": 9661,
	"./arrow-right.svg": 3422,
	"./chevron-down.svg": 6298,
	"./close.svg": 2704,
	"./facebook.svg": 1811,
	"./flag-be.svg": 713,
	"./flag-nl.svg": 4543,
	"./insta.svg": 7771,
	"./instagram.svg": 5045,
	"./logo-mdlz.svg": 180,
	"./youtube.svg": 1311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2289;